import { GetStartedStoreTypes } from "interfaces";

export const initialState: GetStartedStoreTypes = {
  relationship: {
    first_name: "",
    state: "",
    divided_assets: "",
    reached_agreement: "",
    relationship: "",
    defacto_live_2y: "",
    separated_2y: "",
    divorced: "",
    divorced_1y: "",
    bfa_exists: ""
  },
  finance: {
    real_estate: "",
    super_split: "",
    overseas_assets: "",
    business: "",
    business_trust: "",
    other_trust: "",
    property_consent_lodged: "",
    joint_assets_1_5m_exceed: "",
    real_estate_num: 0,
    super_split_num: 0,
    business_nt_num: 0,
    business_trust_num: 0,
    trust_num: 0
  },
  package: "" as "essential" | "full",
  legal_fees: 0
};

export const stepperSteps = [
  {
    label: "Relationship Details",
    id: 1
  },
  {
    label: "Asset Information",
    id: 2
  },
  // {
  //   label: "AI Chat",
  //   id: 3
  // },
  {
    label: "Summary",
    id: 3
  }
];
